import React from 'react';
import PropTypes from 'prop-types';
import {
  Radar,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
} from 'recharts';

function CategoryRadar({ data, minScore, maxScore }) {
  return (
    <RadarChart
      cx="50%"
      cy="50%"
      outerRadius="70%"
      width={400}
      height={300}
      data={data}
    >
      <PolarGrid />
      <PolarAngleAxis dataKey="primaryType" />
      <PolarRadiusAxis
        domain={[
          Math.floor(Math.max(minScore - 10, 0) / 10) * 10,
          Math.ceil(Math.min(maxScore + 10, 100) / 10) * 10,
        ]}
      />
      <Radar
        name="Current"
        dataKey="current"
        stroke="#8884d8"
        fill="#8884d8"
        fillOpacity={0.6}
      />
      {/* <Radar
        name="Last Year"
        dataKey="previous"
        stroke="#82ca9d"
        fill="#82ca9d"
        fillOpacity={0.6}
      /> */}
    </RadarChart>
  );
}

CategoryRadar.propTypes = {
  data: PropTypes.arrayOf(Object),
  minScore: PropTypes.number,
  maxScore: PropTypes.number,
};

export default CategoryRadar;
